module.exports = __webpack_public_path__ + "img/lobby_bar.4dddf157.png";